import {
  GET_DMX_COMPATIBLE_DEVICES,
  GET_DMX_COMPATIBLE_DEVICES_SUCCESS,
  GET_DMX_COMPATIBLE_DEVICES_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDmxCompatibleDevices: '',
  loadingGetDmxCompatibleDevices: false,
  devices: null,
};

const getCompatibleDevices = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_COMPATIBLE_DEVICES:
      state = { ...state, loadingGetDmxCompatibleDevices: true };
      break;
    case GET_DMX_COMPATIBLE_DEVICES_SUCCESS:
      state = { ...state, loadingGetDmxCompatibleDevices: false, devices: action.payload.devices };
      break;
    case GET_DMX_COMPATIBLE_DEVICES_ERROR:
      state = { ...state, errorGetDmxCompatibleDevices: action.payload, loadingGetDmxCompatibleDevices: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getCompatibleDevices;
